import './App.css';
import * as React from 'react';
import MainContent from "./components/MainContent";

export default function App() {

    return (
        <MainContent/>
    );
}